import { NUMBERED_REF_TOKEN_RE } from '../../../lib/citationTokens';
import { stripConfidenceComments } from '../../../lib/reportRendering/narrativeArtifacts';

// Display-only card prose for Analyses and Recommended path. Source text,
// full report sections and the expanded provenance ledger stay untouched.
const DOC_ANCHOR = String.raw`doc:\/\/[^\s()[\]<>"',;!?]+`;
const REFERENCE = `(?:${NUMBERED_REF_TOKEN_RE.source}|\\[Ref\\s*\\?\\]|${DOC_ANCHOR})`;
const REFERENCE_RUN = new RegExp(`${REFERENCE}(?:[ \\t]*,?[ \\t]*${REFERENCE})*`, 'gi');

const ACCORDING_TO_SOURCES_RE =
  /(^|[.!?]\s+)According to (?:the )?data available from (?:Project Intent|[""\u201c][^\n""\u201d]+[""\u201d])(?:,\s*(?:and\s+)?[""\u201c][^\n""\u201d]+[""\u201d]|\s+and\s+[""\u201c][^\n""\u201d]+[""\u201d])*,\s*/gi;

const REDUNDANT_PHASE_ADDITION_RE =
  /\b(Phase\s+(\d+)\s+delivers\s+(\d+(?:\.\d+)?\s*MW)\s+cumulative\s+facility\s+demand)\s*\(\s*Phase\s+\2\s+adds\s+\3\s+facility\s+demand,\s*corresponding\s+to\s+([^()]+)\)/gi;

const PLANNING_DEFAULT_VERDICT_RE =
  /\bwith a (FEASIBLE|INFEASIBLE|CONDITIONAL) planning-default ELCC firm-capacity verdict\s*\[inferred planning default\]/gi;

/** Remove reference handles from card prose, preserving uncertainty and every
 * sentence. Numbered data brackets and non-reference qualifiers are not handles. */
export function analysisCardSummary(text: string): string {
  return stripConfidenceComments(text)
    .replace(REFERENCE_RUN, run => {
      const qualifications = [...new Set([...run.matchAll(/\b(verified|inferred|unverified)\s+Ref\b/gi)]
        .map(match => match[1]!.toLowerCase()))];
      // Document anchors are frequently followed by the sentence's full stop.
      // Keep that punctuation even though the rest of the anchor is omitted.
      const punctuation = /[.:]+$/.exec(run)?.[0] ?? '';
      return `${qualifications.length ? `(${qualifications.join('; ')})` : ''}${punctuation}`;
    })
    .replace(/\(\s*[,;:]\s*/g, '(')
    .replace(/\s*[,;:]\s*\)/g, ')')
    .replace(/[ \t]*\(\s*\)/g, '')
    .replace(ACCORDING_TO_SOURCES_RE, '$1')
    .replace(REDUNDANT_PHASE_ADDITION_RE, '$1 ($4)')
    .replace(
      PLANNING_DEFAULT_VERDICT_RE,
      (_match, verdict: string) => `with a ${verdict.toLowerCase()} planning-default ELCC firm-capacity verdict (inferred)`,
    )
    .replace(/[ \t]+([.,;:!?])/g, '$1')
    .replace(/[ \t]{2,}/g, ' ')
    .trim();
}
